import { createAction } from '@reduxjs/toolkit';
import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { QcsSyncResourcesPayload } from 'app-components/flux/core/resourceStoreTypes';
import type {
  Address,
  AddressProps,
  Profile,
  ProfileProps,
  ProfilePropsImmu,
  getVerifyStatusResponse,
  verifyIdentityResponse,
  verifyPayload,
} from './profileTypes';

const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const syncProfilePayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<ProfilePropsImmu>>();
const profilePayloadCreator = getPayloadCreator<Profile | ProfileProps>();

const addressPayloadCreator = getPayloadCreator<Address | AddressProps>();
const syncAddressPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<AddressProps>>();

export const getProfile = createAction('GET_PROFILE', getPayloadCreator());
export const getProfileSuccess = createAction('GET_PROFILE_SUCCESS', syncProfilePayloadCreator);
export const getProfileFailure = createAction('GET_PROFILE_FAILURE', errorPayloadCreator);

export const updateProfile = createAction('UPDATE_PROFILE', profilePayloadCreator);
export const updateProfileSuccess = createAction('UPDATE_PROFILE_SUCCESS', syncProfilePayloadCreator);
export const updateProfileFailure = createAction('UPDATE_PROFILE_FAILURE', errorPayloadCreator);

export const createAddress = createAction('CREATE_ADDRESS', addressPayloadCreator);
export const createAddressSuccess = createAction('CREATE_ADDRESS_SUCCESS', syncAddressPayloadCreator);
export const createAddressFailure = createAction('CREATE_ADDRESS_FAILURE', errorPayloadCreator);

export const updateAddress = createAction('UPDATE_ADDRESS', addressPayloadCreator);
export const updateAddressSuccess = createAction('UPDATE_ADDRESS_SUCCESS', syncAddressPayloadCreator);
export const updateAddressFailure = createAction('UPDATE_ADDRESS_FAILURE', errorPayloadCreator);

export const verifyEmail = createAction('VERIFY_EMAIL', getPayloadCreator());
export const verifyEmailSuccess = createAction('VERIFY_EMAIL_SUCCESS'); // TODO: maybe do something with success?
export const verifyEmailFailure = createAction('VERIFY_EMAIL_FAILURE', errorPayloadCreator);

export const createPhone = createAction('CREATE_PHONE', getPayloadCreator());
// create is actually done on quicken.com myAccount page in a new tab, this just triggers client-side polling in the sagas
export const verifyPhone = createAction('VERIFY_PHONE', getPayloadCreator());
export const verifyPhoneSuccess = createAction('VERIFY_PHONE_SUCCESS'); // TODO: maybe do something with success?
export const verifyPhoneFailure = createAction('VERIFY_PHONES_FAILURE', errorPayloadCreator);

export const getVerificationStatus = createAction('GET_VERIFICATION_STATUS', getPayloadCreator());
export const getVerificationStatusSuccess = createAction(
  'GET_VERIFICATION_STATUS_SUCCESS',
  getPayloadCreator<getVerifyStatusResponse>(),
);
export const getVerificationStatusFailure = createAction('GET_VERIFICATION_STATUS_FAILURE', errorPayloadCreator);

export const verifyIdentity = createAction('VERIFY_IDENTITY', getPayloadCreator<verifyPayload>());
export const verifyIdentitySuccess = createAction(
  'VERIFY_IDENTITY_SUCCESS',
  getPayloadCreator<verifyIdentityResponse>(),
);
export const verifyIdentityFailure = createAction('VERIFY_IDENTITY_FAILURE', errorPayloadCreator);
